
export const RefundPolicyUrl = "https://d2djimvzddgguw.cloudfront.net/company-policies/RefundPolicy.json";
export const PrivacyPolicyUrl = "https://d2djimvzddgguw.cloudfront.net/company-policies/PrivacyPolicy.json";
export const CancellationPolicyUrl = "https://d2djimvzddgguw.cloudfront.net/company-policies/Cancellation.json";
export const TNCUrl = "https://d2djimvzddgguw.cloudfront.net/company-policies/tnc.json";